import React from "react";
import Typography from "@material-ui/core/Typography";

export default function Title(props) {
	return (
		<Typography
			variant="h6"
			color="primary"
			className={props.className}
			style={{ marginBottom: 0, whiteSpace: "nowrap", ...props.style }}
		>
			{props.children}
		</Typography>
	);
}
